import { render, staticRenderFns } from "./DeleteUserType.vue?vue&type=template&id=0e0d3c54&scoped=true"
import script from "./DeleteUserType.vue?vue&type=script&lang=js"
export * from "./DeleteUserType.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserType.vue?vue&type=style&index=0&id=0e0d3c54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d3c54",
  null
  
)

export default component.exports